var _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRpmSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 84,
    viewBox: "0 0 93 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3434 28L81.0516 28L92.25 41.2042L80.9459 54.25H45.2905C45.1056 50.1567 45 46.0634 45 41.9437C45 37.2694 45.1056 32.6743 45.3434 28Z",
    fill: "url(#paint0_linear_2547_10008)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint1_linear_2547_10008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_10008",
    x1: 44.4477,
    y1: 41.125,
    x2: 91.1335,
    y2: 41.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2547_10008",
    x1: 42,
    y1: -0.981836,
    x2: 42,
    y2: 82.0151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046085"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpmSpinner);
export default __webpack_public_path__ + "static/media/rpmSpinner.b448ffb4d6b370f11a0cfe7d3343028c.svg";
export { ForwardRef as ReactComponent };